import Vue from 'vue';
import ENV from 'browser-environment';

export default new Vue({
  data() {
    return {
      browser: false,
      opera: false,
      firefox: false,
      safari: false,
      ie: false,
      ie10: false,
      ie11: false,
      edge: false,
      chrome: false,
      iPhone: false,
      iPad: false,
      iPod: false,
      android: false,
      mac: false,
      win: false,
      ios: false,
      retina: false,
      touchScreen: false,
      userTouching: false,
      userHovering: false,
      utilityFocus: false,
      pointerFocus: false,
      viewport: null,
      $ENV: null,
    };
  },
  created() {
    this.$ENV = ENV;
    this.$ENV.subscribe(this.fill);
    this.fill(this.$ENV.getEnv());
  },
  beforeDestroy() {
    if (this.$ENV) {
      this.$ENV.unsubscribe(this.fill);
    }
  },
  methods: {
    fill(state) {
      if (!state) return;

      Object.keys(state).forEach((key) => {
        if (key !== '$ENV') {
          this[key] = state[key];
        }
      });
    },
  },
});
